<!-- Main Content Container -->
<div class="flex flex-col min-h-0 space-y-3">
    <!-- Page Header Section -->
    <section class="flex flex-col p-6 space-y-5 bg-white rounded shadow md:p-8">
        <h1 class="text-2xl font-bold md:text-3xl">Connection Requests {{ type }}</h1>
    </section>

    <!-- Table Section -->
    <section class="bg-white rounded shadow list-table-section">
        <div class="p-2 table-container md:p-6">
            <app-data-table
                [columns]="columns"
                [data]="requests"
                [meta]="meta"
                [rowActions]="actions"
                [page]="page"
                [loading]="loading"
                [error]="null"
                [showPageInput]="false"
                [stickyHeader]="true"
                style="--sticky-header-top: -24px"
                (rowAction)="onRowAction($event)"
                (pageChange)="onPageChange($event)"
                class="w-full"
            >
            </app-data-table>
        </div>
    </section>
</div>

<ng-template #connectionModal let-onAcceptRequest="onAcceptRequest" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Do you want to accept the connection request?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-green-600 border border-transparent rounded hover:bg-green-700 flex items-center justify-center"
                (click)="onAcceptRequest()"
            >
                Accept
            </button>
        </div>
    </div>
</ng-template>

<ng-template #connectionDisconnectModal let-onConfirmRequest="onConfirmRequest" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to decline connection with {{ type }}?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
            >
                Cancel
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-white bg-red-600 border border-transparent rounded hover:bg-red-700 flex items-center justify-center"
                (click)="onConfirmRequest()"
            >
                Confirm
            </button>
        </div>
    </div>
</ng-template>

<ng-template #muteModal let-onConfirm="onConfirm" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to proceed?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
                [disabled]="loading"
            >
                No
            </button>
            <app-button
                type="button"
                label="Yes"
                btnClass="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary border border-transparent rounded hover:bg-tertiary-80 flex items-center justify-center"
                [disabled]="loading"
                [isLoading]="isSubmitting"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>
